var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",attrs:{"data-component-name":_vm.$options.name}},[_c('div',[_c('router-view',{attrs:{"email":_vm.email,"reset_token":_vm.reset_token}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }